/*
 * @Author: your name
 * @Date: 2022-01-05 17:18:20
 * @LastEditTime: 2022-01-05 19:49:01
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \bidding-systemd:\项目\engineer-management-system\src\views\PC\login1\Login.js
 */
import sliderVerify from '@/components/slider-verify.vue'
import Vue from 'vue'
import * as api from './api/LoginUtil'
import ElementUI from 'element-ui';
Vue.use(ElementUI)

export default {
    name: "Login",
    components: {
        sliderVerify
    },
    data() {
        return {
            show: true,
            /* login */
            selectTitleList: [
                { name: '登 录', id: '0', className: 'Login' },
                // { name: '注 册', id: '1', className: 'register' },
            ],
            /* 是否记住密码 */
            isRemember: false,
            selectTitleActive: '0',
            username: '',
            password: '',
            isMobileFlag: JSON.parse(localStorage.getItem('isMobileFlag')),
        }
    },
    mounted() {
        if (this.isMobileFlag) {
            let width = this.$refs.verifyValue?.offsetWidth
            this.sliderWidth = width
        }
        let autoLogin = JSON.parse(localStorage.getItem('projectAutoLogin'))
        let { uid, upwd, isRemember } = autoLogin
        this.username = isRemember ? uid : ''
        this.password = isRemember ? upwd : ''
        this.isRemember = isRemember ? true : false
    },
    watch: {
        confirmSuccess(newVal) {
            if (newVal) {
                this.showVerify = true
            }
        }
    },
    methods: {
        login() {
            let {
                username: uid,
                password: upwd,
            } = this

            let params = { uid, upwd }
            //cusername: 是前后端商量好的参数 冒号后面的是变量名
            //将请求的参数传给loginPost方法，.then后面的是后台返回的数据
            api.loginPost(params).then(data => {

                if (data.data.resultObject == -1) {
                    this.$message({ message: '用户名错误', type: 'warning' })
                } else if (data.data.resultObject == -2) {
                    this.$message({ message: '密码错误', type: 'warning' })
                } else {
                    let userInfo = data.data.resultObject
                    let { uid } = params
                    params.isRemember = this.isRemember
                    localStorage.setItem("appToken", userInfo.userToken);
                    localStorage.setItem('userInfo', JSON.stringify(userInfo))
                    localStorage.removeItem('pageNo')
                    localStorage.setItem('projectAutoLogin', JSON.stringify(params))
                    this.$store.commit('Login/USER_INFO', userInfo)
                    let { query } = this.$route
                    console.log(this.$route);
                    if (Object.values(query).length) {
                        this.$router.push({
                            path: query.path,
                            query: query
                        })
                    } else {
                        this.$router.push('/index');
                    }
                }

            })
        },
        keyLogin(e) {
            if (e.keyCode === 13) this.login()
        },
        /* 华为手机登录copyright被顶上去 */
        handleInputFocus() {
            if (this.isMobileFlag) {
                this.$refs.copyRight.style.display = 'none'
            }
        }
    }
}
